import Reflux from 'reflux';

const HistogramDataActions = Reflux.createActions({
  load: { asyncResult: true },
});

export default HistogramDataActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/sources/HistogramDataActions.js